import api from './api';
import { queueAll, queueRemove, queueAdd } from './offlineDb';

let syncing = false;

// Queue an evidence record locally (used when offline or when a live POST fails).
export function enqueueEvidence({ circle_id, event_type, title, meta, fileBlob, fileName }) {
  return queueAdd({ circle_id, event_type, title, meta: meta || '', fileBlob: fileBlob || null, fileName: fileName || null });
}

// Push every queued record to the server. Preserves the offline timestamp.
// Signing / hash-chaining happens server-side at this point.
export async function flushQueue() {
  if (syncing || !navigator.onLine) return { synced: 0 };
  syncing = true;
  let synced = 0;
  try {
    const items = await queueAll();
    for (const it of items) {
      try {
        let fileId = null;
        if (it.fileBlob) {
          const fd = new FormData();
          fd.append('file', it.fileBlob, it.fileName || 'evidence');
          const up = await api.post('/files/upload', fd);
          fileId = up.data.file_id;
        }
        await api.post('/evidence', {
          circle_id: it.circle_id, event_type: it.event_type,
          title: it.title, meta: it.meta,
          payload: { recorded_offline_at: it.recorded_at },
          file_id: fileId,
        });
        await queueRemove(it.localId);
        synced += 1;
      } catch (e) {
        // Stop on connectivity loss; skip auth-less items (will retry next time).
        if (!navigator.onLine) break;
        if (e?.response?.status === 401) break;
      }
    }
  } finally {
    syncing = false;
  }
  return { synced };
}
